import { DailyParticipant } from "@daily-co/daily-js";
import { User, getInitialUser } from "../models/User";
import { ExtendedDailyParticipant } from "@daily-co/daily-react";

export const createRoom = async () => {
  const exp = Math.round(Date.now() / 1000) + 60 * 30;
  const options = {
    properties: {
      exp,
      enable_prejoin_ui: false, // TODO: remove me when robots are no longer needed
    },
  };

  /*
    This endpoint is using the proxy as outlined in netlify.toml.
    Comment this out if you want to use the local option below.
  */
  // const response = await fetch(`${window.location.origin}/api/rooms`, {
  //   method: "POST",
  //   body: JSON.stringify(options),
  // });

  /*
    Uncomment the request below to test the "create room" functionality locally.
    Don't forget to comment out the request above, too!
  */
  const response = await fetch('https://api.daily.co/v1/rooms/', {
    method: 'POST',
    body: JSON.stringify(options),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + process.env.REACT_APP_DAILY_API_KEY,
    },
  });

  return await response.json(); 

/*
  Example response from createRoom
  api_created: true
  config: {exp: 1710976289, enable_prejoin_ui: false}
  created_at: "2024-03-20T22:41:29.000Z"
  id: "b36c4ed4-4682-4564-9dc0-595f2b08b7f4"
  name : "lQrdUm161xLecm4ybb73"
  privacy : "public"
  url : "https://digital-den.daily.co/lQrdUm161xLecm4ybb73"
*/
}

export const createOwnerMeetingToken = async (roomName: string) => {
  const options = {
    properties: {
      room_name: roomName,
      is_owner: true,
    }
  }

  const response = await fetch('https://api.daily.co/v1/meeting-tokens', {
    method: 'POST',
    body: JSON.stringify(options),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + process.env.REACT_APP_DAILY_API_KEY,
    },
  });

  return await response.json();
}

export function getUserForParticipant(participant: ExtendedDailyParticipant | null) {
  if (!participant) return getInitialUser();
  const participantTracks = getParticipantTracks(participant);
  const user = new User(participant.user_id,
                        participant.user_name + participant.user_id.substr(0, 4),
                        participant.local,
                        participant.joined_at,
                        participant.session_id,
                        participantTracks.audio,
                        participantTracks.video);
  return user;
}

export function getParticipantTracks(participant: ExtendedDailyParticipant) {
  const tracks = participant?.tracks;
  if (!tracks) return { video: null, audio: null };

  const vt = <{ [key: string]: any }>tracks.video;
  const at = <{ [key: string]: any }>tracks.audio;

  const videoTrack =
    vt?.state === 'playable' ? vt["persistentTrack"] : null;
  const audioTrack =
    at?.state === 'playable' ? at["persistentTrack"] : null;
  return {
    video: videoTrack,
    audio: audioTrack,
  };
}